import { render, staticRenderFns } from "./ScreenCard.vue?vue&type=template&id=053d13d4&scoped=true&"
import script from "./ScreenCard.vue?vue&type=script&lang=js&"
export * from "./ScreenCard.vue?vue&type=script&lang=js&"
import style0 from "./ScreenCard.vue?vue&type=style&index=0&id=053d13d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053d13d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
